import app from 'flarum/common/app';
import PointsLeaderboardWidget from '../common/components/PointsLeaderboardWidget';

app.initializers.add('tf-points-widget', () => {
  // Register widget with the forum-widgets-core extension using app.widgets.add
  if (app.widgets && app.widgets.add) {
    try {
      app.widgets.add({
        key: 'points-leaderboard',
        component: PointsLeaderboardWidget,
        isDisabled: false,
        isUnique: true,
        placement: 'end',
        position: 1
      }, 'tf-points');
    } catch (error) {
      console.warn('Could not register points leaderboard widget:', error);
    }
  } else {
    console.warn('app.widgets not available');
  }
});
